module.exports = __webpack_public_path__ + "img/remainder2.c99bb246.svg";